import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import QuestionProfile from './App';
import GiftQuestionProfile from './components/gift';
import IdentifyCommand from './components/identify_command';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router, Route, Switch, Redirect} from 'react-router-dom'

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <Switch>
        <Route exact path='/' component={() => <QuestionProfile email={''} showEmail={true}/>} />
        <Route exact path='/gift' component={() => <IdentifyCommand/>} />
        <Route exact path='/delivery' component={(obj) => {
          if(obj.location.state){
            return <GiftQuestionProfile id={obj.location.state.id} email={''} showEmail={true}/>
          }
          else{
            return <Redirect to="/gift"/>
          }
        }} />
        <Route exact path='/:email(.+@.+\..+)?' component={(obj) => <QuestionProfile email={obj} showEmail={false}/>} />
        <Route path='*' component={() => {
                                      window.location.href = 'https://www.vinidaily.com/'; 
                                      return null;}}/>
      </Switch>
    </Router>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

